export function getURLByEnv(): string {
    if (process.env.NODE_ENV == "production") {
        return "";
    } else {
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/utils/URL.ts